/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import { css } from '@emotion/react'
import ReactPlayer from 'react-player'
import { jsx } from 'theme-ui'

const VideoModal = ({ src, isOpen, onClose, ...props }) => {
  return (
    <div
      {...props}
      onClick={onClose}
      css={css`
        ${isOpen === true
          ? `position: fixed; top: 0; bottom: 0; left: 0; right: 0;`
          : `display: none;`}
      `}
    >
      <div
        css={css`
          position: fixed;
          background: rgba(0, 0, 0, 0.58);
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
        `}
      />
      <div
        sx={{
          my: 7,
          maxWidth: '90%',
          bg: 'white',
          mx: 'auto',
          position: 'relative',
          zIndex: '20',
        }}
      >
        <ReactPlayer
          sx={{
            width: 'auto !important',
            height: '40em !important',
          }}
          config={{
            vimeo: {
              playerOptions: { width: 640, height: 640 },
            },
          }}
          url={`${isOpen === true ? src : null}`}
          playing
          playsinline
          controls
        />
      </div>
    </div>
  )
}
export { VideoModal }
